import Framework from "../framework/Framework";

// https://webpack.docschina.org/configuration/dev-server/
export class Service extends Framework.ServiceBase {
    public header = {
        Authorization: "",
    };

    public token = "";

    public setHeader(header: string) {
        const tokenHeader = {
            Authorization: header,
        };
        this.header = tokenHeader;
        Framework.DefaultHttp.setheader(tokenHeader);
    }

     /**获取验证码 */
     getCode = async (obj: any) => {
        const res = await this.http.post("/ebsapi/message/sendsms/makeSecurityCode", {
            ...obj,
            timestamp: String(Date.now()),
            nonce: crypto.randomUUID(),
        })
        return res.data
    }

    public login = async (vals: { username: string; password: string }): Promise<{ isOk: boolean; msg: string; loginData: any }> => {
        const loginHttp = new Framework.Https.Http();
        loginHttp.setheader({ Authorization: "Basic cGlnOnBpZw==" });

        const loginRequestParams = new URLSearchParams();
        loginRequestParams.append("username", vals.username);
        loginRequestParams.append("password", vals.password);
        loginRequestParams.append("grant_type", "password");
        loginRequestParams.append("scope", "server"); 

        const response = await loginHttp.postNotThrowError("/ebsapi/auth/oauth/token", loginRequestParams);
        let isOk = false;
        let msg = "";
        let loginData = {} as any
        if (response.status === 200) {
            isOk = true;
            loginData = response.data;

            const tokenType = loginData.token_type;
            const accessToken = loginData.access_token;
            const refreshToken = loginData.refresh_token;
            this.setHeader(tokenType + " " + accessToken);
            this.token = accessToken;

            sessionStorage.setItem("refreshToken", refreshToken);
            sessionStorage.setItem("accessToken", accessToken);

            //window.ff.Socket.create();
        } else {
            msg = response.data.msg;
        }

        return { isOk, msg, loginData};
    };

        /**注册 */
    register = async (obj: any) => {
            /**去除空格 */
            obj.name = obj.name.replace(/\s*/g, "");
            const res = await this.http.post("/ebsapi/admin/user/register", obj)
            return res.data
        }

    public caLogin = async (dto: object) => {
        const loginHttp = new Framework.Https.Http();
        loginHttp.setheader({ Authorization: "Basic cGlnOnBpZw==" });
        // 部分参数 需要转成base64 
        (dto as any).secret = window.btoa((dto as any).secret);
        (dto as any).sign = window.btoa((dto as any).sign); 
        (dto as any).data = window.btoa((dto as any).data);
        const response = await loginHttp.getOnly("ebsapi/auth/oauth/token",dto)
        let isOk = false;
        let msg = "";
        let loginData = {} as any
        if (response.status === 200) {
            isOk = true;
            loginData = response.data;
            const tokenType = loginData.token_type;
            const accessToken = loginData.access_token;
            const refreshToken = loginData.refresh_token;
            this.setHeader(tokenType + " " + accessToken);
            this.token = accessToken;

            sessionStorage.setItem("refreshToken", refreshToken);
            sessionStorage.setItem("accessToken", accessToken);

        } else {
            msg = response.data.msg;
        }

        return { isOk, msg, loginData };
    }

    // public getUserInfo = async () => {
    //     const userInfoData = await this.http.get("/ebsapi/admin/user/myinfo");
    //     const userInfo = userInfoData.data;

    //     if (userInfo.sysUserVo.username == null) {
    //         throw new Error(" userInfo.sysUser.username不能为空");
    //     }

    //     if (userInfo.permissions == null) {
    //         throw new Error("permissions不能为空");
    //     }

    //     if (userInfo.roles == null) {
    //         throw new Error("roles不能为空");
    //     }
    //     console.log({ userInfo })
    //     Framework.CurrentUser.login({
    //         userType: userInfo.sysUserVo.userType,
    //         userId: userInfo.sysUserVo.userId,
    //         username: userInfo.sysUserVo.username,
    //         subjectId: userInfo.sysUserVo.subjectId,
    //         subjectName: userInfo.sysUserVo.subjectName,
    //         roles: userInfo.roles,
    //         permissions: userInfo.permissions,
    //         tokenHeader: this.header,
    //         token: this.token,
    //         userRealName: userInfo.sysUserVo.userRealName,
    //         engineer: userInfo.sysUserVo.systemEngineer
    //     });
    // };

}
